module.exports = __webpack_public_path__ + "img/finance_1.345d68dd.svg";